module.exports = __webpack_public_path__ + "static/mv_sp-7c25fbf02490759abc04331ffc6a6a2d.jpg";